export default __webpack_public_path__ + "static/media/ic_circle_close.b54ae622.svg";